import React from 'react'
import LoadingOverlay from 'apps/LoadingOverlay'
import * as styles from './ProfileContent.scss'

const ProfileContent = ({ children, isLoading }) => (
  <div className={styles.root}>
    {isLoading && (<LoadingOverlay />)}
    <div className='container'>
      {children}
    </div>
  </div>
)

export default ProfileContent
